export function getFullName(title: string, firstName: string, middleName: string, lastName: string, suffix: string): string {
   let fullName = `${lastName}, `;
   if (title) fullName += `${title} `;
   if (firstName) fullName += `${firstName} `;
   if (middleName) fullName += `${middleName} `;
   if (suffix) fullName += `${suffix} `;
   return fullName;
}
